<script setup lang="ts">
import { ref } from 'vue';
// TODO improve this

interface CheckBoxOptions {
  text: string,
  value: string | boolean
}

const model = defineModel<Array<string>>({ required: true });

defineProps<{
  options: Array<CheckBoxOptions>,
  disabled?: boolean
}>();

const selectedOptions = ref(model.value);

const updateSelection = (): void => {
  model.value = selectedOptions.value;
};
</script>
<template>
  <div>
    <label v-for="(option, index) in options" :key="index" class="flex items-center">
      <input type="checkbox" :value="option.value" v-model="selectedOptions" @change="updateSelection" class="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out" :disabled="disabled" />
      <slot>
        <span class="ml-2 text-gray-700 cursor-pointer">{{ option.text }}</span>
      </slot>
    </label>
  </div>
</template>
